import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_tit">공제 항목</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제대상 신용카드 등의 범위 및 공제율</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제금액</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_cont">
                <div className="item">① 근로자 본인</div>
                <div className="item">② 기본공제대상 배우자</div>
                <div className="item">
                  ③ 기본공제대상 직계비속‧입양자‧직계존속(배우자의 직계존속 포함) (연령 제한 없음){' '}
                </div>
                <div className="item">
                  ※ 참고 형제자매, 수급자 및 위탁아동은 신용카드 등 사용액에 대하여 공제 불가함
                </div>
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont ">
                <div className="item">∙ 신용카드 등 사용금액＝㉠+㉡+㉢+㉣+㉤</div>
                <div className="item">㉠ 전통시장 사용액 : 1~3월분 40%, 4~12월분 50%</div>
                <div className="item">㉡ 대중교통 사용액 : 80%</div>
                <div className="item">
                  ㉢ 도서공연등 사용액(총급여 7천만원 이하자) :1~3월분 30%, 4~12월분 40%
                </div>
                <div className="item">
                  ㉣ 현금영수증, 직불카드 등 사용액(전통시장 사용분 및 대중교통 이용분 제외) : 30%
                </div>
                <div className="item">
                  ㉤ 신용카드 사용액(전통시장 사용분 및 대중교통 이용분 제외) : 15%
                </div>
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont ">
                <div className="item">∙ 신용카드 등 소득공제액=①,② 중 적은 금액</div>
                <div className="item">① 신용카드 등 소득공제액: 초과사용금액×공제율</div>
                <div className="item">
                  ② 한도액 : ㉠+㉡
                  <div className="item_l2">
                    ㉠기본한도:급여수준별 차등 적용
                    <div className="item_l3">ⓐ 7천만원 이하 : 300만원</div>
                    <div className="item_l3">ⓑ 7천만원 초과 : 250만원</div>
                  </div>
                  <div className="item_l2">
                    ㉡추가한도:
                    <div className="item_l3">
                      (1) 총급여 7천만원 이하 : Min[기본한도초과액,
                      전통시장사용액×공제율＋대중교통사용액×공제율, 도서공연등사용액×공제율,
                      300만원]
                    </div>
                    <div className="item_l3">
                      (2) 총급여 7천만원 초과 : Min[기본한도초과액,
                      전통시장사용액×공제율＋대중교통사용액×공제율, 200만원]
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
